import { Inject, Injectable, InjectionToken, Optional } from '@angular/core';
import {
    browserSupportsWebAuthn,
    PublicKeyCredentialCreationOptionsJSON,
    PublicKeyCredentialRequestOptionsJSON,
    startAuthentication,
    startRegistration,
} from '@simplewebauthn/browser';

export interface PasskeyBrowserProvider {
    isSupported(): boolean;
    register(options: PublicKeyCredentialCreationOptionsJSON | object): Promise<unknown>;
    authenticate(options: PublicKeyCredentialRequestOptionsJSON | object): Promise<unknown>;
}

export const PASSKEY_BROWSER_PROVIDER = new InjectionToken<PasskeyBrowserProvider>(
    'PASSKEY_BROWSER_PROVIDER'
);

const defaultProvider: PasskeyBrowserProvider = {
    isSupported: browserSupportsWebAuthn,
    register: (options) =>
        startRegistration({ optionsJSON: options as PublicKeyCredentialCreationOptionsJSON }),
    authenticate: (options) =>
        startAuthentication({ optionsJSON: options as PublicKeyCredentialRequestOptionsJSON }),
};

@Injectable({ providedIn: 'root' })
export class PasskeyBrowserService {
    private provider: PasskeyBrowserProvider;

    constructor(
        @Optional()
        @Inject(PASSKEY_BROWSER_PROVIDER)
        provider?: PasskeyBrowserProvider
    ) {
        this.provider = provider ?? defaultProvider;
    }

    public isSupported(): boolean {
        return this.provider.isSupported();
    }

    public register(options: PublicKeyCredentialCreationOptionsJSON | object): Promise<unknown> {
        return this.provider.register(options);
    }

    public authenticate(options: PublicKeyCredentialRequestOptionsJSON | object): Promise<unknown> {
        return this.provider.authenticate(options);
    }
}
